<template>
  <div class="grids">
    <naj-loader v-if="getGridConfigLoading"></naj-loader>
    <naj-data-table
      v-else-if="headers && headers.length"
      ref="selection"
      :headers="computedHeaders"
      :items="value"
      :disable-items-per-page="true"
      :title="title"
      :no-header="noHeader"
    >
      <template slot-scope="{ item }">
        <v-btn
          v-if="editAction && !viewMode"
          icon
          @click="selectEditItem(item)"
        >
          <v-icon color="primary">
            mdi-lead-pencil
          </v-icon>
        </v-btn>

        <v-btn
          v-if="viewAction"
          icon
          @click="selectViewItem(item)"
        >
          <v-icon color="primary">
            mdi-eye
          </v-icon>
        </v-btn>

        <v-btn
          v-if="deleteAction && !viewMode"
          icon
          @click="removeItem(item)"
        >
          <v-icon color="red">
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
    </naj-data-table>
    <dynamic-form-modal
      :modal-visibility="formModal.show"
      :view-mode="formModal.viewMode"
      :submit-button-text="formModal.submitButtonText"
      :title="gridConfig.formLabel"
      :fields="gridConfig.fields"
      :custom-component-name="gridConfig.customComponentName"
      :initial-form-model="gridConfig.initialFormModel"
      :form-model="selectedItem"
      :root-form-model="rootFormModel"
      :data-sources="dataSources"
      :validate-on-submit="true"
      :required-data="requiredData"
      @onClose="closeModal"
      @formSubmitted="formModalSubmitted"
    ></dynamic-form-modal>

    <v-row v-if="addAction && !viewMode">
      <v-col
        cols="1"
        class="mb-6"
      >
        <naj-button
          icon="mdi-plus"
          @click="
              openFormModal({
                viewMode,
                submitButtonText: local.common.add,
              })
            "
        >
        </naj-button>
      </v-col>
    </v-row>
    <!-- <dynamic-form-modal
      :modal-visibility="modal.show == 'dynamic-form-modal'"
      :fields="modal.fields"
      :submit-button-text="modal.submitButtonText"
      @onClose="closeModal"
      @formSubmitted="addItem"
    ></dynamic-form-modal> -->

    <naj-confirmation
      :show-modal="showRemovePopup"
      color="error"
      :title="local.common.removeConfirmation"
      :message="local.common.removeConfirmationMessage"
      :ok-btn-label="local.common.remove"
      @ok="removeConfirmed"
      @cancel="showRemovePopup = false"
    ></naj-confirmation>
    <naj-error-text
      v-if="errorMessage"
      :text="errorMessage"
    ></naj-error-text>
  </div>
</template>

<script>
import { modalPosition, actionType, httpMethod } from '@/helpers/enum';
import { executeString, uuidGenerator } from '@/helpers/utils';
import DynamicFormModal from './dynamic-form-modal';
import globalModuleAPIs from '@/modules/global/services/api';

export default {
  name: 'Grids',
  $_veeValidate: {
    name() {
      return this.title;
    },
    value() {
      return this.value;
    },
  },
  components: { DynamicFormModal },
  props: ['value', 'title', 'config', 'viewMode', 'errorMessage', 'rootFormModel', 'dataSources', 'noHeader', 'requiredData', 'fieldProperties'],
  data() {
    return {
      rowNumber: 0,
      executeString,
      selectedRows: [],
      searchQuery: {},
      modalPosition,
      actionType,
      httpMethod,
      width: '1200',
      modal: {
        show: '',
        fields: null,
        submitButtonText: null,
        params: {},
      },
      formModal: {
        show: false,
        fields: null,
        viewMode: false,
        submitButtonText: null,
      },
      tableLoading: false,
      isAdvancedSearchExpanded: false,
      showRemovePopup: false,
      selectedItem: {},
      gridConfig: {},
      getGridConfigLoading: false,
    };
  },
  computed: {
    headers() {
      return this.gridConfig.headers;
    },
    computedHeaders() {
      const headersWithActions = [...this.headers];
      if (this.isNumericGrid()) {
        headersWithActions.unshift({
          text: 'الترقيم',
          value: 'number',
          align: 'start',
        });
      }
      headersWithActions.push({
        text: ' ',
        value: 'action',
      });
      return headersWithActions;
    },
    actions() {
      return this.gridConfig.actions;
    },
    addAction() {
      return this.actions && this.actions.find(action => action.actionType == actionType.addNew);
    },
    editAction() {
      return this.actions && this.actions.find(action => action.actionType == actionType.edit);
    },
    deleteAction() {
      return this.actions && this.actions.find(action => action.actionType == actionType.delete);
    },
    viewAction() {
      return this.actions && this.actions.find(action => action.actionType == actionType.view);
    },
    computedActions() {
      return this.actions.map(action => ({
        ...action,
        ...JSON.parse(action.properties),
      }));
    },
  },
  watch: {
    config: {
      deep: true,
      handler() { this.loadGridConfig(); },
    },
  },
  mounted() {
    if (this.isNumericGrid()) {
      this.rowNumber = this.value.length;
      this.value.forEach((item, index) => {
        item.number = index + 1;
      });
    }
    this.loadGridConfig();
  },
  methods: {
    isNumericGrid() {
      const data = JSON.parse(this.fieldProperties);
      return data.isNumeric;
    },
    loadGridConfig() {
      if (this.config.headers && this.config.headers.length) {
        this.gridConfig = this.config;
        if (this.gridConfig.formId) {
          this.getGridConfigLoading = true;
          globalModuleAPIs.getDynamicForm(this.gridConfig.formId)
            .then((res) => {
              if (res.data.isCustom)
                this.gridConfig.customComponentName = res.data.customComponentName;
              else
                this.gridConfig.fields = res.data.fields;
            })
            .finally(() => {
              this.getGridConfigLoading = false;
            });
        }
      } else {
        this.getGridConfigLoading = true;
        globalModuleAPIs.getDynamicGrid(this.config.gridId)
          .then((res) => {
            this.gridConfig = res.data.configurations;
            globalModuleAPIs.getDynamicForm(this.gridConfig.formId)
              .then((res) => {
                if (res.data.isCustom)
                  this.gridConfig.customComponentName = res.data.customComponentName;
                else
                  this.gridConfig.fields = res.data.fields;
              })
              .finally(() => {
                this.getGridConfigLoading = false;
              });
          });
      }
    },
    openFormModal({ viewMode = false, submitButtonText }) {
      this.formModal = {
        ...this.formModal,
        submitButtonText,
        show: true,
        viewMode,
      };
    },
    openModal({ componentName, params, fields, submitButtonText }) {
      this.modal.show = componentName;
      this.modal.params = params || {};
      this.modal.fields = fields || [];
      this.modal.submitButtonText = submitButtonText;
    },
    closeModal() {
      this.modal.show = '';
      this.formModal.show = false;
      setTimeout(() => {
        this.formModal.viewMode = false;
        this.selectedItem = {};
        this.modal.params = {};
      }, 250);
    },
    addItem(item) {
      this.rowNumber = (this.value || []).length;
      const newItem = {
        ...item,
        objectKey: uuidGenerator(),
        number: this.isNumericGrid() ? ++this.rowNumber : undefined,
      };
      this.updateValues([...(this.value || []), newItem]);
    },
    editItem(item) {
      if (!item.number && this.isNumericGrid())
        item.number = ++this.rowNumber;
      this.updateValues(this.value.map(i => (i.objectKey == item.objectKey ? item : i)));
    },
    formModalSubmitted(item) {
      if (this.headers) {
        this.headers.forEach(header => {
          if (item[header.value] === undefined) {
            const nameKey = Object.keys(item).find(
              key => key.toLowerCase() === (header.value + 'Name').toLowerCase()
            );
            if (nameKey && item[nameKey] != null) {
              item[header.value] = item[nameKey];
              return;
            }
            const matchKey = Object.keys(item).find(
              key => key.toLowerCase() === header.value.toLowerCase()
            );
            if (matchKey) item[header.value] = item[matchKey];
          }
        });
      }
      item.objectKey ? this.editItem(item) : this.addItem(item);
    },
    updateValues(value) {
      this.$emit('update:value', value);
    },
    selectViewItem(item) {
      this.selectedItem = item;
      this.openFormModal({ viewMode: true });
    },
    selectEditItem(item) {
      this.selectedItem = item;
      this.openFormModal({
        viewMode: this.viewMode,
        submitButtonText: this.local.common.save,
      });
    },
    removeItem(item) {
      this.selectedItem = item;
      this.showRemovePopup = true;
    },
    removeConfirmed() {
      const updatedValues = this.value.filter(item => item.objectKey != this.selectedItem.objectKey);
      if (this.isNumericGrid()) {
        updatedValues.forEach((item, index) => {
          item.number = index + 1;
        });
        this.rowNumber = updatedValues.length;
      }
      this.updateValues(updatedValues);
      this.selectedItem = {};
      this.showRemovePopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-data-table__wrapper {
  border: 1px solid #e8e8e8;
}
::v-deep .ivu-table-header th {
  background-color: #eee !important;
}
.layout-actions {
  position: absolute;
  top: 19px;
  left: 50px;
}
.grid-actions {
  display: inline-flex;
}
.action-button {
  margin-bottom: 7px;
}
.icon {
  margin-right: 15px;
}
.up {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  // -webkit-transition-duration: 1s;
  // -moz-transition-duration: 1s;
  // -o-transition-duration: 1s;
  // transition-duration: 1s;
}
.advanced-search-btn {
  font-size: 20px;
  line-height: 23px;
  font-weight: 400;
  color: #252733;
  cursor: pointer;
}
::v-deep .v-data-table-header {
  border-top: none !important;
}
::v-deep .v-data-table tbody tr:hover {
  background-color: #fcfcfc !important;
}
</style>
